/**
 * Author: postcodex
 * Date: 10/5/20
 * Time: 5:58 PM
 */
import { put, call, takeLatest } from 'redux-saga/effects';
import { apiRequest } from '../../../api';
import { SEARCH_ADDRESSES, SEARCH_ADDRESSES_SUCCESS, SEARCH_ADDRESSES_ERROR } from '../actions';

//region Regular AJAX request
function* sendSearchAddresses( action ) {
	const { data, error } = yield call( apiRequest, action.payload );

	if ( data ) {
		yield put( { type : SEARCH_ADDRESSES_SUCCESS, data } );
	} else {
		yield put( { type : SEARCH_ADDRESSES_ERROR, error } );
	}
}

export function* watchSearchAddresses() {
	yield takeLatest( SEARCH_ADDRESSES, sendSearchAddresses );
}

//endregion
